type ErrorOptions = {
  silent?: boolean;
};

export class Fetcher {
  /**
   * Handles GET requests, returns JSON if possible or handles errors
   * @param endpoint
   */
  async get<Return>(endpoint: string) {
    const init = {
      method: "GET",
    };

    const response = await fetch(endpoint, init);
    if (response.ok) return (await response.json()) as Return;
    else this.error(response);
  }

  /**
   * Handles POST requests, returns JSON if possible or handles errors
   * @param endpoint
   */
  async post<Return, Body>(endpoint: string, body: Body) {
    const init = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: typeof body === "string" ? body : JSON.stringify(body),
    };

    const response = await fetch(endpoint, init);
    if (response.ok) return (await response.json()) as Return;
    else this.error(response);
  }

  /**
   * Handles errors, and supports either printing errors or throwing them
   * @param endpoint
   */
  async error(response: Response, options: ErrorOptions = {}) {
    const { silent } = options;
    const error = await response.json();

    if (silent) console.error("Fetcher Error:", error.description);
    else throw error;
  }
}
